<template>
  <div>
    <div v-for="item in items" :key="item.id">
      <ListItemResult v-if="item.typeShow == 'text'" :value="item.value">
        <div class="d-flex flex-wrap align-center">
          <div class="pa-2 pl-0 text-subtitle-2 text-label"
            >{{ item.field.name }}:</div
          >
          <div class="pa-2">{{ item.value }}</div>
        </div>
      </ListItemResult>
      <div
        class="d-flex px-4 flex-column"
        v-if="['image', 'video'].includes(item.typeShow)"
      >
        <div class="pa-2 pl-0 text-subtitle-2 text-label"
          >{{ item.field.name }}:</div
        >
        <div class="pa-2">
          <ListitemFileViewResult
            :url="item.value"
            :type="item.typeShow"
            v-if="item.value"
          />
          <div v-else>Không có tệp tin đính kèm</div>
        </div>
      </div>
      <RegionListItemResult
        v-if="item.typeShow == 'region'"
        :field="item.field"
        :value="item.value"
      >
      </RegionListItemResult>
      <ListItemResult v-if="item.typeShow == 'array'">
        <ArrayListItemResult :field="item.field" :value="item.value">
        </ArrayListItemResult>
      </ListItemResult>
    </div>
  </div>
</template>

<script>
import { convertFormToListField } from '@models/field-2/form'

import ListItemResult from './list-item-result.vue'
import ListitemFileViewResult from './listitem-file-view-result.vue'
import RegionListItemResult from './region-list-item-result.vue'
import ArrayListItemResult from './array-list-item-result.vue'
export default {
  components: {
    ListItemResult,
    RegionListItemResult,
    ListitemFileViewResult,
    ArrayListItemResult,
  },
  props: {
    value: { type: Object, required: true },
    fields: { type: Array, required: true },
  },
  watch: {
    value: { handler: 'initData', deep: true, immediate: true },
    fields: { handler: 'initData', deep: true, immediate: true },
  },
  data: () => ({ items: [] }),
  computed: {},
  methods: {
    initData() {
      if (!this.fields || this.fields.length < 1) return
      this.items = convertFormToListField(
        this.value,
        this.fields.filter((x) => x.type != 'geometry')
      ).filter((x) => !!x.value)
    },
  },
}
</script>

<style scoped>
.text-label {
  font-weight: 700;
}
</style>
